module.exports = __webpack_public_path__ + "img/(金苹果)花园城幼儿园、天府新区.d41c7403.jpg";